import { createIcon } from './createIcon'

export const MilestoneMegaphoneIcon = createIcon({
  displayName: 'MilestoneMegaphoneIcon',
  viewBox: '0 0 12 13',

  path: [
    <path
      fill="none"
      id="Icon"
      d="M10.5 4.7591V6.52553M2.85 7.62955V9.50638C2.85 9.60891 2.85 9.66018 2.85433 9.70336C2.89642 10.1227 3.23449 10.4544 3.66179 10.4957C3.70579 10.5 3.75803 10.5 3.8625 10.5C3.96698 10.5 4.01922 10.5 4.06322 10.4957C4.49052 10.4544 4.82858 10.1227 4.87067 9.70336C4.875 9.66018 4.875 9.60891 4.875 9.50638V7.62955M2.85 7.62955C2.43065 7.62955 2.22098 7.62955 2.05558 7.56232C1.83506 7.47268 1.65985 7.30074 1.56851 7.08433C1.5 6.92202 1.5 6.71626 1.5 6.30473L1.5 5.7748C1.5 5.03283 1.5 4.66185 1.64714 4.37845C1.77657 4.12917 1.98309 3.9265 2.23711 3.79948C2.52589 3.65508 2.90393 3.65508 3.66 3.65508H4.875M2.85 7.62955H4.875M4.875 7.62955H5.2125C6.00739 7.62955 6.97976 8.0477 7.72993 8.44902C8.16757 8.68314 8.38639 8.8002 8.52971 8.78297C8.6626 8.767 8.76309 8.70844 8.84099 8.60158C8.925 8.48634 8.925 8.25575 8.925 7.79459V3.49005C8.925 3.02888 8.925 2.7983 8.84099 2.68306C8.76309 2.57619 8.6626 2.51764 8.52971 2.50166C8.38639 2.48444 8.16757 2.6015 7.72993 2.83562C6.97976 3.23693 6.00739 3.65508 5.2125 3.65508H4.875M4.875 7.62955V3.65508"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
})
